import React from 'react';

import { IconProps } from './types';

export const AwardIcon: React.FC<IconProps> = ({ className }) => {
  return (
    <svg
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M32.6529 10.0653V11.422L26.1629 7.66366C23.7063 6.25199 20.2779 6.25199 17.8396 7.66366L11.3496 11.4403V10.0653C11.3496 5.94033 13.6046 3.66699 17.7296 3.66699H26.2729C30.3979 3.66699 32.6529 5.94033 32.6529 10.0653Z"
        fill="white"
      />
      <path
        d="M32.708 14.6121L32.4513 14.4838L29.958 13.0538L24.788 10.0654C23.2113 9.14876 20.7913 9.14876 19.2146 10.0654L14.0446 13.0354L11.5513 14.5021L11.2213 14.6671C8.01297 16.8304 7.79297 17.2338 7.79297 20.6988V28.9854C7.79297 32.4504 8.01297 32.8538 11.2946 35.0721L19.2146 39.6371C20.003 40.1138 20.993 40.3154 22.0013 40.3154C22.9913 40.3154 23.9996 40.0954 24.788 39.6371L32.7813 35.0171C36.008 32.8538 36.2096 32.4688 36.2096 28.9854V20.6988C36.2096 17.2338 35.9896 16.8304 32.708 14.6121ZM27.1163 24.7504L25.998 26.1254C25.8146 26.3271 25.6863 26.7121 25.7046 26.9871L25.8146 28.7471C25.888 29.8288 25.118 30.3788 24.1096 29.9938L22.478 29.3338C22.2213 29.2421 21.7996 29.2421 21.543 29.3338L19.9113 29.9754C18.903 30.3788 18.133 29.8104 18.2063 28.7288L18.3163 26.9688C18.3346 26.6938 18.2063 26.3088 18.023 26.1071L16.8863 24.7504C16.1896 23.9254 16.5013 23.0088 17.5463 22.7338L19.2513 22.2938C19.5263 22.2204 19.838 21.9638 19.9846 21.7438L20.938 20.2771C21.5246 19.3604 22.4596 19.3604 23.0646 20.2771L24.018 21.7438C24.1646 21.9821 24.4946 22.2204 24.7513 22.2938L26.4563 22.7338C27.5013 23.0088 27.813 23.9254 27.1163 24.7504Z"
        fill="white"
      />
    </svg>
  );
};
